const imgPath = '/imgPath/img/'

// const backPath = 'http://localhost:8888/api/v1/'
const backPath = 'http://120.78.136.147:8888/api/v1/'


export default{
    imgPath,
    backPath
}